import {USER_LOGIN_REQUEST, USER_LOGIN_SUCCESS, USER_LOGIN_FAILURE,RESET_LOGIN_ERROR} from './constants';

export function loginUser (data) {
    return {
        type: USER_LOGIN_REQUEST,
        data
    }
}

export function loginUserSuccess (data) {
    return {
        type: USER_LOGIN_SUCCESS,
        data
    }
}

export function loginUserFailure (data) {
    return {
        type: USER_LOGIN_FAILURE,
        data
    }
}

export function resetLoginError (data) {
    return {
        type: RESET_LOGIN_ERROR,
        data
    }
}



// WEBPACK FOOTER //
// ./src/containers/Layouts/Default/Signin/actions.js